var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"new-product--flag flex__center link__none",attrs:{"to":_vm.link}},[_c('font-awesome-icon',{attrs:{"icon":"certificate","size":"3x"}}),_c('span',[_vm._v("NEW")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }